import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { LimitedSpots } from './LimitedSpots';
export function HeroSection() {
  // Imágenes de mujeres mexicanas para social proof
  const socialProofImages = ['https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces', 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=faces', 'https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?w=100&h=100&fit=crop&crop=faces'];
  const handleCTAClick = () => {
    // Track AddToCart event
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart', {
        content_name: 'Guía TikTok Shop',
        content_category: 'Digital Product',
        value: 190,
        currency: 'MXN'
      });
    }
  };
  return <section className="relative overflow-hidden bg-gradient-premium pt-6 pb-12 md:min-h-[90vh] md:flex md:items-center" data-id="element-400">
      {/* Subtle decorative elements */}
      <div className="absolute inset-0 opacity-20" data-id="element-401">
        <div className="absolute top-20 left-10 w-96 h-96 bg-rose-gold/30 rounded-full blur-3xl" data-id="element-402"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-champagne-gold/30 rounded-full blur-3xl" data-id="element-403"></div>
      </div>

      <div className="container-premium relative z-10" data-id="element-404">
        {/* Social proof badge con imágenes reales */}
        <div className="flex justify-center mb-6 animate-fade-in" data-id="element-405">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-white rounded-full shadow-soft border border-champagne-gold/20" data-id="element-406">
            <div className="flex -space-x-2" data-id="element-407">
              {socialProofImages.map((image, i) => <img key={i} src={image} alt={`Mujer mexicana ${i + 1}`} width="20" height="20" loading="eager" decoding="async" className="w-5 h-5 rounded-full border-2 border-white object-cover" data-id="element-408" />)}
            </div>
            <span className="text-xs font-semibold text-deep-cocoa" data-id="element-409">
              <span className="text-cta-primary" data-id="element-410">2,347 mujeres</span> ya están
              ganando
            </span>
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-411">
          {/* Left: Copy */}
          <div className="text-center lg:text-left space-y-6 animate-fade-in-up" data-id="element-412">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black text-deep-cocoa leading-tight" data-id="element-413">
              Gana <span className="text-gradient-orange" data-id="element-414">$500-$2,000</span> MXN
              Extra Cada Semana
            </h1>

            <p className="text-lg sm:text-xl text-deep-cocoa/80 font-medium" data-id="element-415">
              Sistema paso a paso para vender en TikTok Shop desde tu celular
            </p>

            <ul className="space-y-2.5" data-id="element-416">
              {['Sin inventario ni inversión inicial', 'Sin experiencia previa necesaria', 'Solo 1-2 horas al día desde casa'].map((item, i) => <li key={i} className="flex items-center gap-2.5 text-deep-cocoa/90" data-id="element-417">
                  <div className="flex-shrink-0 w-5 h-5 rounded-full bg-accent-success/10 flex items-center justify-center" data-id="element-418">
                    <CheckIcon className="w-3.5 h-3.5 text-accent-success" data-id="element-419" />
                  </div>
                  <span className="text-sm sm:text-base" data-id="element-420">{item}</span>
                </li>)}
            </ul>

            {/* CTA */}
            <div className="space-y-3 pt-2" data-id="element-421">
              <a href="https://buy.stripe.com/dRm28rgfodEa83g1X618c00" onClick={handleCTAClick} className="group inline-flex items-center justify-center gap-2.5 px-7 py-3.5 bg-gradient-to-r from-cta-primary to-cta-secondary text-white text-base font-bold rounded-xl shadow-glow-orange hover:shadow-xl hover:scale-105 transition-all duration-300 w-full sm:w-auto" data-id="element-422">
                Quiero Empezar Ahora
                <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-423" />
              </a>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 text-xs text-deep-cocoa/70" data-id="element-424">
                <span className="flex items-center gap-1" data-id="element-425">
                  <CheckIcon className="w-3.5 h-3.5 text-accent-success" data-id="element-426" />
                  Acceso inmediato
                </span>
                <span className="flex items-center gap-1" data-id="element-427">
                  <CheckIcon className="w-3.5 h-3.5 text-accent-success" data-id="element-428" />
                  Solo $190 MXN
                </span>
                <span className="flex items-center gap-1" data-id="element-429">
                  <CheckIcon className="w-3.5 h-3.5 text-accent-success" data-id="element-430" />
                  Garantía 30 días
                </span>
              </div>
            </div>
          </div>

          {/* Right: Product + Urgency */}
          <div className="space-y-4 animate-fade-in" style={{
          animationDelay: '200ms'
        }} data-id="element-431">
            {/* Product image - OPTIMIZADA */}
            <div className="relative" data-id="element-432">
              <div className="relative z-10 rounded-2xl overflow-hidden shadow-premium" data-id="element-433">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/m4yThtScr4RZyGecczd1NM/Untitled_design_%2862%29.png" alt="Guía TikTok Shop" width="600" height="800" loading="eager" decoding="async" fetchPriority="high" className="w-full h-auto" data-id="element-434" />
              </div>
              {/* Glow effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-cta-primary/20 to-cta-secondary/20 rounded-2xl blur-2xl -z-10 animate-pulse-soft" data-id="element-435"></div>
            </div>

            {/* Urgency elements */}
            <div className="space-y-3" data-id="element-436">
              <CountdownTimer data-id="element-437" />
              <LimitedSpots data-id="element-438" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}